import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-heading text-xl font-medium text-midnight mb-3">{title}</h2>
    <div className="text-midnight/60 text-sm leading-relaxed space-y-3">{children}</div>
  </div>
);

const Layout = ({ title, description, children }) => (
  <div className="bg-white min-h-screen">
    <Seo title={title} description={description} />
    <Nav />
    <main className="pt-44 pb-24">
      <div className="max-w-[820px] mx-auto px-6 lg:px-10">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold mb-6">Legal — Royal Deals FZ-LLC</p>
        <h1 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-midnight mb-12">{title.split(" — ")[0]}</h1>
        {children}
      </div>
    </main>
    <Footer />
  </div>
);

export function PrivacyPage() {
  return (
    <Layout title="Privacy Policy — Royal Deals FZ-LLC" description="Privacy policy of Royal Deals FZ-LLC.">
      <Section title="1. Who we are">
        <p>Royal Deals FZ-LLC is a technology trading company registered in Ras Al Khaimah, United Arab Emirates (Ras Al Khaimah Economic Zone — RAKEZ). This policy explains how we handle information submitted through this website.</p>
      </Section>
      <Section title="2. Information we collect">
        <p>When you submit a requirement (RFQ), an enquiry or use the Requirement Builder, we collect the details you provide: company name, contact name, business email, telephone, country, requirement details and any documents you upload.</p>
      </Section>
      <Section title="3. How we use it">
        <p>Information is used solely to assess, qualify and respond to your commercial enquiry, and to manage the resulting business relationship. We do not sell personal data.</p>
      </Section>
      <Section title="4. Sharing">
        <p>Requirement details may be shared with supply partners where necessary to assess availability, and only at the level of detail appropriate to the transaction. Confidentiality requests made in the requirement form are honoured.</p>
      </Section>
      <Section title="5. Marketing communications and consent">
        <p>Marketing emails are sent only with your explicit consent, recorded with its date, source and wording. Every campaign email includes a working unsubscribe link, and you can update your interests at any time instead of unsubscribing completely. Completing an RFQ or enquiry does not subscribe you to marketing.</p>
      </Section>
      <Section title="6. Retention and rights">
        <p>Enquiry records are retained for commercial and compliance purposes. You may request access to, correction of, export or deletion of your information by contacting us through this website or at info@royaldealsfzllc.com.</p>
      </Section>
    </Layout>
  );
}

export function TermsPage() {
  return (
    <Layout title="Terms of Use — Royal Deals FZ-LLC" description="Terms of use of the Royal Deals FZ-LLC website.">
      <Section title="1. Nature of this website">
        <p>This website is a commercial presentation of Royal Deals FZ-LLC. Nothing on it constitutes an offer to sell, a quotation, a price list, or a guarantee of product availability. All transactions are subject to individual commercial agreement.</p>
      </Section>
      <Section title="2. Availability and pricing">
        <p>Availability indicators on this website are illustrative. Stock, allocation, pricing and lead times are confirmed only in writing against a qualified requirement, and remain subject to compliance, export and destination requirements.</p>
      </Section>
      <Section title="3. Trademarks">
        <p>Manufacturer names, part numbers and trademarks referenced in enquiries remain the property of their respective owners. Their submission does not imply authorisation, endorsement or affiliation.</p>
      </Section>
      <Section title="4. Acceptable use">
        <p>You agree to submit accurate company and requirement information and to use this website only for legitimate business purposes.</p>
      </Section>
      <Section title="5. Liability">
        <p>To the maximum extent permitted by applicable law, Royal Deals FZ-LLC accepts no liability for decisions made on the basis of website content. Contractual terms agreed in writing prevail.</p>
      </Section>
    </Layout>
  );
}
